<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="550px"
        transition="slide-y-transition"
        eager
        :persistent="actionLoading"
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Dodawanie nowego procesu
                    <template v-if="isAddingProcessBefore">
                        przed procesem
                    </template>
                    <template v-else>
                        po procesie
                    </template>
                    <strong>"{{ task.process.name }}"</strong>
                </h1>
            </v-card-title>

            <v-card-text class="pa-0">
                <v-container fluid class="px-6 py-2">
                    <v-row>
                        <v-col cols="12">
                            <v-autocomplete
                                v-model="processId"
                                :items="processes"
                                label="Proces"
                                item-value="id"
                                item-text="name"
                                no-data-text="Nie znaleziono procesów"
                                outlined
                                dense
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    :disabled="actionLoading"
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    :loading="actionLoading"
                    data-sentry-label="Zapisz"
                    @click="onSave"
                >
                    Dodaj
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ProcessesAvailableToAddDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        taskData: {
            type: Object,
            default: null
        },
        processesData: {
            type: Object,
            default: null
        },
        actionLoading: {
            type: Boolean
        }
    },
    data() {
        return {
            task: {
                process: {}
            },
            processes: [],
            processId: null
        }
    },
    computed: {
        isAddingProcessBefore() {
            return this.task.placement === 'before'
        },
    },
    watch: {
        isOpen(value) {
            if (value) {
                this.task = JSON.parse(JSON.stringify(this.taskData))

                if (this.isAddingProcessBefore) {
                    this.processes = this.processesData.previousProcesses
                } else {
                    this.processes = this.processesData.nextProcesses
                }
            } else {
                setTimeout(() => {
                    this.task = {
                        process: {}
                    }
                    this.processes = []
                    this.processId = null
                }, 500)
            }
        }
    },
    methods: {
        onSave() {
            if (!this.actionLoading) {
                const payload = {
                    processId: this.processId
                }

                if (this.isAddingProcessBefore) {
                    payload['nextTaskId'] = this.task.id
                } else {
                    payload['previousTaskId'] = this.task.id
                }

                this.$emit('on-save', payload)
            }
        },
        onClose() {
            if (!this.actionLoading) {
                setTimeout(() => {
                    this.processes = []
                    this.processId = null
                }, 500)

                this.$emit('on-close')
            }
        },
    }
}
</script>
